export const MaticLogo =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/thumbnail_polygon_matic_logo_718ba904c3.png?width=2000&height=2000";

export const EtherLogo =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/thumbnail_ethlogo_0ac84ee82b.png?width=3258&height=3258";

export const WalletD =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/thumbnail_wallet_D_c7286e1d32.png?width=193&height=200";

export const BrandLogo =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/thumbnail_DC_2b78de6397.png?width=400&height=372";

export const hardhatLogo =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/hardhat.png";

export const PikaAsh =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/Pika_Ash_d61783eff1.gif?width=356&height=394";

export const Logo3D =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/3dLogo.png";

export const LogoRound =
  "https://deepcity-dev.s3.ap-south-1.amazonaws.com/LogoRound.png";

export const Logo = "https://deepcity-dev.s3.ap-south-1.amazonaws.com/logo.png";

export const looks =
  "https://deepcityimages.s3.ap-south-1.amazonaws.com/entity/looks.png";
export const opensea =
  "https://deepcityimages.s3.ap-south-1.amazonaws.com/entity/open.png";

export async function fetchAsset(url: string) {
  const response = await fetch(url);
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
